module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "WevrLogoSecondary.c31fdafd.svg";